import Flex from 'quarks/Flex';
import Image, { ImageData } from 'quarks/Image';

import type { ContentfulComponentSingleInstance } from 'graphqlTypes';
import type { FC } from 'react';

type ImageBannerProps = ContentfulComponentSingleInstance;

const ImageBanner: FC<ImageBannerProps> = ({ fileReference }) => (
  <Flex width="100%" height="fit-content" position="relative">
    {fileReference?.[0] && (
      <Image
        image={fileReference[0] as ImageData}
        alt=""
        width="100%"
        height="100%"
        objectFit="cover"
        objectPosition="center"
      />
    )}
  </Flex>
);

export default ImageBanner;
